import * as React from 'react'
import { Button, Icon } from '@metrisk/react_metrisk-components'

import Field from '@components/Field'

import campaignConfig from '@config/campaign'

const defaultFields: any = {
  purchasePrice: {
    name: 'purchasePrice',
    type: 'currency',
    label: 'Price',
  },
  quantity: {
    name: 'quantity',
    type: 'number',
    label: 'Quantity',
    min: 1,
    max: 99,
    validation: (value: any) => value && /^[0-9]+$/.test(value),
  },
}

const PurchaseItem = ({ index, item, formFields, canDelete, onItemUpdate, onDelete }: any) => {
  const itemFields = Object.keys(item.fields)

  const getValue = (field: string) => {
    return item.fields[field].value
  }

  const getProps = (field: string): any => {
    const foundField = formFields.find((formField: any) => formField.id === field)
    const props = foundField ? { ...foundField.props } : { ...defaultFields[field] }

    const { validation, ...elementProps } = props

    if (index > 0) {
      delete elementProps.label
    }

    return {
      ...elementProps,
      currency: campaignConfig.campaignCurrency,
    }
  }

  const isValid = (field: string, value: any): boolean => {
    if (value === null) return false

    if (defaultFields[field]?.validation) {
      return defaultFields[field]?.validation(value)
    }

    return Boolean(value)
  }

  const handleChange = (field: string, value: any) => {
    onItemUpdate(item.id, field, value, isValid(field, value))
  }

  const handleDelete = () => {
    onDelete(item.id)
  }

  return (
    <div className="purchase-item">
      {itemFields.map((field: any) => {
        return (
          <Field
            key={`${item.id}-${field}`}
            {...getProps(field)}
            value={getValue(field)}
            valid={getValue(field) === null ? true : isValid(field, getValue(field))}
            onChange={(value: any) => handleChange(field, value)}
            required
          />
        )
      })}
      {canDelete && (
        <Button type={'Secondary'} className="purchase-item__remove" onClick={handleDelete}>
          <Icon name={'Cross'} size={'Large'} />
        </Button>
      )}
    </div>
  )
}

export default PurchaseItem
